import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import {
  fetchWristbandRedeemCodes,
  addWristbandRedeemCode,
  deleteRedeemCode,
  updateRedeemCode,
} from "../actions/redeemcodes";
import { fetchMachines } from "../actions/machines";
import { fetchCustomersName, fetchCustomer } from "../actions/customers";

import ErrorMessage from "../components/ErrorMessage";
import LoadingProgress from "../components/LoadingProgress";
import FeatureBlockedScreen from "../components/FeatureBlockedScreen";
import "../styles/RedeemCodesView.css";

const LOCKER_TYPES = [
  { code: "BNS", name: "Standard" },
  { code: "CNS", name: "Standard Carga" },
  { code: "BWS", name: "Standard XL" },
  { code: "CWS", name: "Standard Carga XL" },
  { code: "BNM", name: "Medium" },
  { code: "CNM", name: "Medium Carga" },
  { code: "BWM", name: "Medium XL" },
  { code: "CWM", name: "Medium Carga XL" },
  { code: "BNL", name: "Large" },
  { code: "CNL", name: "Large Carga" },
  { code: "BWL", name: "Large XL" },
  { code: "CWL", name: "Large Carga XL" },
  { code: "BNXL", name: "Large 4" },
  { code: "CNXL", name: "Large 4 Carga" },
  { code: "BWXL", name: "Large 4 XL" },
  { code: "CWXL", name: "Large 4 Carga XL" },
  { code: "BN2XL", name: "Large 5" },
  { code: "CN2XL", name: "Large 5 Carga" },
  { code: "BW2XL", name: "Large 5 XL" },
  { code: "CW2XL", name: "Large 5 Carga XL" },
  { code: "BN3XL", name: "Ski" },
  { code: "CN3XL", name: "Ski Carga" },
  { code: "BW3XL", name: "Ski XL" },
  { code: "CW3XL", name: "Ski Carga XL" },
  { code: "XNS", name: "Standard Cupón" },
  { code: "XWS", name: "Standard XL Cupón" },
  { code: "XNM", name: "Medium Cupón" },
  { code: "XWM", name: "Medium XL Cupón" },
  { code: "XNL", name: "Large Cupón" },
  { code: "XWL", name: "Large XL Cupón" },
  { code: "XNXL", name: "Large 4 Cupón" },
  { code: "XWXL", name: "Large 4 XL Cupón" },
  { code: "XN2XL", name: "Large 5 Cupón" },
  { code: "XW2XL", name: "Large 5 XL Cupón" },
  { code: "XN3XL", name: "Ski Cupón" },
  { code: "XW3XL", name: "Ski XL Cupón" },
];

// Accepts: Mifare Classic 4-byte (8), 7-byte (14), 10-byte (20), UUID without hyphens (32), UUID with hyphens
const RFID_UID_REGEX = /^([0-9a-fA-F]{8}|[0-9a-fA-F]{14}|[0-9a-fA-F]{20}|[0-9a-fA-F]{32}|[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/;

function isValidRfidUid(val) {
  return RFID_UID_REGEX.test(val);
}

class WristbandRedeemCodesView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      filterCode: "",
      // RFID scanning panel
      rfidBuffer: "",
      rfidError: "",
      scannerActive: false,
      // creation form
      showForm: false,
      pendingUUID: "",
      newRedeemCode: {
        customer: "",
        origin: "internal",
        products: [],
        valid_from: "",
        valid_to: "",
        code: "",
      },
      currentProductId: "",
      currentProductQty: 1,
      // edit modal
      showEditModal: false,
      editRedeemCode: null,
      editProductId: "",
      editProductQty: 1,
      // redeemed modal
      showRedeemedModal: false,
      selectedRedeemedCode: null,
    };

    this.rfidInputRef = React.createRef();
    this.handleRfidKeyDown = this.handleRfidKeyDown.bind(this);
    this.handleRfidChange = this.handleRfidChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleProductChange = this.handleProductChange.bind(this);
    this.addProduct = this.addProduct.bind(this);
    this.removeProduct = this.removeProduct.bind(this);
    this.openEditModal = this.openEditModal.bind(this);
    this.closeEditModal = this.closeEditModal.bind(this);
    this.handleEditInputChange = this.handleEditInputChange.bind(this);
    this.handleEditSubmit = this.handleEditSubmit.bind(this);
    this.handleDeleteRedeemCode = this.handleDeleteRedeemCode.bind(this);
    this.showRedeemedModal = this.showRedeemedModal.bind(this);
    this.closeRedeemedModal = this.closeRedeemedModal.bind(this);
  }

  componentDidMount() {
    const { role, customerId, fetchMachines, fetchCustomersName } = this.props;
    this.props.fetchWristbandRedeemCodes(role !== 'ADMIN' ? customerId : undefined);

    if (role === 'CUSTOMER' && customerId) {
      this.props.fetchCustomer(customerId);
    }

    fetchMachines();

    if (role === "ADMIN") {
      fetchCustomersName();
    }

    this.load(this.props);

    // Auto-focus RFID input
    if (this.rfidInputRef.current) {
      this.rfidInputRef.current.focus();
    }
  }

  componentDidUpdate(prevProps) {
    this.load(this.props);

    if (
      this.props.wristbandRedeemCodesNeedRefresh &&
      !prevProps.wristbandRedeemCodesNeedRefresh
    ) {
      const { role, customerId } = this.props;
      this.props.fetchWristbandRedeemCodes(role !== 'ADMIN' ? customerId : undefined);
    }
  }

  load(props) {
    const { role, machines, customers } = props;
    if (!this.state.loaded && machines && (role !== "ADMIN" || customers)) {
      this.setState({ loaded: true });
    }
  }

  // RFID reader acts as keyboard: types UID chars and sends Enter
  handleRfidChange(e) {
    this.setState({ rfidBuffer: e.target.value, rfidError: "" });
  }

  handleRfidKeyDown(e) {
    if (e.key === "Enter") {
      e.preventDefault();
      const uid = this.state.rfidBuffer.trim();
      if (!uid) return;

      if (!isValidRfidUid(uid)) {
        this.setState({ rfidError: `El valor leído "${uid}" no es un UID RFID válido. Asegúrate de que el lector RFID está configurado correctamente.` });
        return;
      }

      const { role, customerId } = this.props;
      this.setState({
        rfidBuffer: "",
        rfidError: "",
        showForm: true,
        pendingUUID: uid,
        newRedeemCode: {
          customer: role === "ADMIN" ? "620d1664db950220fabc0a41" : customerId,
          origin: "internal",
          products: [],
          valid_from: "",
          valid_to: "",
          code: uid,
        },
        currentProductId: "",
        currentProductQty: 1,
      });
    }
  }

  handleInputChange(e) {
    const { name, value } = e.target;
    const updated = { ...this.state.newRedeemCode, [name]: value };
    if (name === 'valid_from' && updated.valid_to && value && updated.valid_to < value) {
      updated.valid_to = '';
    }
    this.setState({ newRedeemCode: updated });
  }

  handleProductChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  addProduct() {
    const { currentProductId, currentProductQty, newRedeemCode } = this.state;
    if (!currentProductId || !currentProductQty) return;
    const locker = LOCKER_TYPES.find((l) => l.code === currentProductId);
    if (!locker) return;
    const product = {
      product_id: null,
      product_name: currentProductId,
      product_qty: parseInt(currentProductQty),
      product_price: 0,
    };
    this.setState({
      newRedeemCode: { ...newRedeemCode, products: [...newRedeemCode.products, product] },
      currentProductId: "",
      currentProductQty: 1,
    });
  }

  removeProduct(index) {
    const { newRedeemCode } = this.state;
    const products = [...newRedeemCode.products];
    products.splice(index, 1);
    this.setState({ newRedeemCode: { ...newRedeemCode, products } });
  }

  handleSubmit(e) {
    e.preventDefault();
    const { newRedeemCode } = this.state;
    const sanitized = {
      ...newRedeemCode,
      machine: null,
      valid_from: newRedeemCode.valid_from || null,
      valid_to: newRedeemCode.valid_to || null,
    };
    this.props.addWristbandRedeemCode(sanitized);
    this.setState({
      showForm: false,
      pendingUUID: "",
      newRedeemCode: { customer: "", origin: "internal", products: [], valid_from: "", valid_to: "", code: "" },
      currentProductId: "",
      currentProductQty: 1,
    });
    setTimeout(() => {
      if (this.rfidInputRef.current) this.rfidInputRef.current.focus();
    }, 100);
  }

  openEditModal(redeemCode) {
    const d2s = (date) => {
      if (!date) return "";
      const d = new Date(date);
      return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}T${String(d.getHours()).padStart(2,'0')}:${String(d.getMinutes()).padStart(2,'0')}`;
    };
    this.setState({
      showEditModal: true,
      editRedeemCode: {
        _id: redeemCode._id,
        customer: redeemCode.customer,
        origin: redeemCode.origin || "internal",
        products: [...redeemCode.products],
        valid_from: d2s(redeemCode.valid_from),
        valid_to: d2s(redeemCode.valid_to),
        code: redeemCode.code,
      },
      editProductId: "",
      editProductQty: 1,
    });
  }

  closeEditModal() {
    this.setState({ showEditModal: false, editRedeemCode: null });
  }

  handleEditInputChange(e) {
    const { name, value } = e.target;
    this.setState({ editRedeemCode: { ...this.state.editRedeemCode, [name]: value } });
  }

  handleEditSubmit(e) {
    e.preventDefault();
    const { editRedeemCode } = this.state;
    const { _id, ...updates } = editRedeemCode;
    this.props.updateRedeemCode(_id, { ...updates, machine: null });
    this.closeEditModal();
  }

  handleDeleteRedeemCode(id) {
    if (window.confirm("¿Está seguro de que desea eliminar este código de pulsera?")) {
      this.props.deleteRedeemCode(id);
    }
  }

  showRedeemedModal(redeemCode) {
    this.setState({ showRedeemedModal: true, selectedRedeemedCode: redeemCode });
  }

  closeRedeemedModal() {
    this.setState({ showRedeemedModal: false, selectedRedeemedCode: null });
  }

  getTypeName(code) {
    const found = LOCKER_TYPES.find((l) => l.code === code);
    return found ? found.name : code;
  }

  getCustomerName(customerId) {
    const { role, customers, customerFullname } = this.props;
    if (role !== 'ADMIN') return customerFullname || 'Unknown';
    if (!customers || !customerId) return "Unknown";
    const customer = customers.find((c) => c._id === customerId);
    return customer ? customer.Fullname : "Unknown";
  }

  getMachineSerial(machineId) {
    const { machines } = this.props;
    if (!machines || !machineId) return machineId;
    const machine = machines.find((m) => m._id === machineId);
    return machine ? machine.Serial : machineId;
  }

  render() {
    const {
      role, wristbandRedeemCodes, wristbandLoading, wristbandError,
      machines, customers, customer,
    } = this.props;

    if (role === 'CUSTOMER' && customer && customer.FeatureWristbandCodes === false) {
      return <FeatureBlockedScreen featureName="FeatureWristbandCodes" featureLabel="Códigos de Pulsera (RFID)" />;
    }

    const {
      showForm, newRedeemCode, loaded, filterCode,
      rfidBuffer, rfidError, pendingUUID, scannerActive,
      showRedeemedModal, selectedRedeemedCode,
    } = this.state;

    const filteredCodes = wristbandRedeemCodes
      ? wristbandRedeemCodes.filter((rc) =>
          rc.code.toLowerCase().includes(filterCode.toLowerCase())
        )
      : [];

    if (wristbandError) {
      return <ErrorMessage message={wristbandError.message} />;
    }

    if (!wristbandRedeemCodes || wristbandLoading) {
      return <LoadingProgress />;
    }

    if (!loaded) {
      return <LoadingProgress />;
    }

    return (
      <div className="redeemcodes-view">
        {/* Header */}
        <div className="redeemcodes-header">
          <div className="redeemcodes-title-section">
            <h1 className="redeemcodes-title">
              <i className="fas fa-id-badge"></i>
              CÓDIGOS DE PULSERA RFID
            </h1>
          </div>
          <div className="redeemcodes-actions">
            <input
              type="text"
              className="filter-input"
              placeholder="Filtrar por UUID"
              value={filterCode}
              onChange={(e) => this.setState({ filterCode: e.target.value })}
              style={{ width: "260px" }}
            />
          </div>
        </div>

        {/* RFID Scanner Panel */}
        <div style={{
          background: "linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)",
          borderRadius: "16px",
          padding: "32px",
          marginBottom: "24px",
          boxShadow: "0 8px 32px rgba(0,0,0,0.3)",
          position: "relative",
          overflow: "hidden",
        }}>
          {/* Decorative background rings */}
          <div style={{
            position: "absolute", top: "-60px", right: "-60px",
            width: "220px", height: "220px", borderRadius: "50%",
            border: "2px solid rgba(255,255,255,0.05)",
            pointerEvents: "none",
          }} />
          <div style={{
            position: "absolute", top: "-30px", right: "-30px",
            width: "160px", height: "160px", borderRadius: "50%",
            border: "2px solid rgba(255,255,255,0.07)",
            pointerEvents: "none",
          }} />

          <div style={{ display: "flex", alignItems: "center", gap: "32px", flexWrap: "wrap" }}>
            {/* Left — scan zone icon */}
            <div
              onClick={() => this.rfidInputRef.current && this.rfidInputRef.current.focus()}
              style={{
                width: "110px", height: "110px", flexShrink: 0,
                borderRadius: "50%",
                background: rfidError
                  ? "rgba(220,53,69,0.2)"
                  : rfidBuffer
                  ? "rgba(40,167,69,0.2)"
                  : scannerActive
                  ? "rgba(0,180,255,0.15)"
                  : "rgba(255,255,255,0.08)",
                border: rfidError
                  ? "3px solid rgba(220,53,69,0.7)"
                  : rfidBuffer
                  ? "3px solid rgba(40,167,69,0.7)"
                  : scannerActive
                  ? "3px solid rgba(0,180,255,0.85)"
                  : "3px dashed rgba(255,255,255,0.3)",
                boxShadow: scannerActive && !rfidError && !rfidBuffer
                  ? "0 0 0 6px rgba(0,180,255,0.15), 0 0 0 12px rgba(0,180,255,0.07)"
                  : "none",
                display: "flex", alignItems: "center", justifyContent: "center",
                flexDirection: "column", gap: "6px",
                cursor: "pointer",
                transition: "all 0.3s ease",
                position: "relative",
              }}
            >
              <i
                className={`fas ${rfidError ? "fa-exclamation-triangle" : rfidBuffer ? "fa-check" : scannerActive ? "fa-broadcast-tower" : "fa-wifi"}`}
                style={{
                  fontSize: "32px",
                  color: rfidError ? "#dc3545" : rfidBuffer ? "#28a745" : scannerActive ? "#00b4ff" : "rgba(255,255,255,0.4)",
                }}
              />
              <span style={{ fontSize: "10px", color: rfidError ? "#dc3545" : rfidBuffer ? "#28a745" : scannerActive ? "#00b4ff" : "rgba(255,255,255,0.35)", textTransform: "uppercase", letterSpacing: "1px", fontWeight: 600 }}>
                {rfidError ? "Error" : rfidBuffer ? "Leído" : scannerActive ? "Activo" : "Lector"}
              </span>
              {!scannerActive && !rfidError && !rfidBuffer && (
                <span style={{ position: "absolute", bottom: "-22px", left: "50%", transform: "translateX(-50%)", whiteSpace: "nowrap", fontSize: "10px", color: "rgba(255,255,255,0.4)", letterSpacing: "0.5px" }}>
                  Toca para activar
                </span>
              )}
            </div>

            {/* Right — instructions + input */}
            <div style={{ flex: 1, minWidth: "240px" }}>
              <h5 style={{ color: "#fff", margin: "0 0 4px", fontWeight: 600, fontSize: "18px" }}>
                Lector RFID
              </h5>
              <p style={{ color: "rgba(255,255,255,0.55)", margin: "0 0 16px", fontSize: "13px", lineHeight: 1.5 }}>
                Haz clic en el campo y acerca la pulsera al lector. El UID se capturará automáticamente.
              </p>

              {/* Hidden-style input that captures the reader output */}
              <div style={{ position: "relative" }}>
                <input
                  ref={this.rfidInputRef}
                  type="text"
                  className="form-control"
                  placeholder="Esperando pulsera RFID…"
                  value={rfidBuffer}
                  onChange={this.handleRfidChange}
                  onKeyDown={this.handleRfidKeyDown}
                  onFocus={() => this.setState({ scannerActive: true })}
                  onBlur={() => this.setState({ scannerActive: false })}
                  autoComplete="off"
                  style={{
                    background: "rgba(255,255,255,0.08)",
                    border: rfidError
                      ? "1.5px solid rgba(220,53,69,0.8)"
                      : "1.5px solid rgba(255,255,255,0.15)",
                    borderRadius: "10px",
                    color: "#fff",
                    fontFamily: "monospace",
                    fontSize: "15px",
                    letterSpacing: "2px",
                    padding: "12px 16px",
                    outline: "none",
                    width: "100%",
                    caretColor: "#fff",
                  }}
                />
              </div>

              {/* Status messages */}
              {rfidError && (
                <div style={{
                  marginTop: "10px", padding: "10px 14px", borderRadius: "8px",
                  background: "rgba(220,53,69,0.15)", border: "1px solid rgba(220,53,69,0.4)",
                  color: "#ff6b7a", fontSize: "13px", display: "flex", alignItems: "center", gap: "8px",
                }}>
                  <i className="fas fa-exclamation-circle" />
                  <span>{rfidError}</span>
                </div>
              )}
              {!rfidError && (
                <div style={{
                  marginTop: "10px", display: "flex", alignItems: "center", gap: "8px",
                  color: "rgba(255,255,255,0.35)", fontSize: "12px",
                }}>
                  <i className="fas fa-info-circle" />
                  <span>Formatos aceptados: Mifare Classic (4/7/10 bytes) y UUID estándar</span>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Create form — shown after RFID scan */}
        {showForm && (
          <div className="vw-modal">
            <div className="vw-modal__backdrop" onClick={() => this.setState({ showForm: false, pendingUUID: "" })} />
            <div className="vw-modal__dialog">
              <div className="vw-modal__header">
                <h5 className="m-0">
                  <i className="fas fa-id-badge mr-2"></i>
                  Crear Código de Pulsera RFID
                </h5>
                <button
                  type="button"
                  className="close"
                  onClick={() => this.setState({ showForm: false, pendingUUID: "" })}
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="vw-modal__body">
                <form onSubmit={this.handleSubmit}>
                  <div className="form-group">
                    <label>UUID de Pulsera</label>
                    <input
                      type="text"
                      className="form-control"
                      value={newRedeemCode.code}
                      readOnly
                      style={{ fontFamily: "monospace", background: "#f8f9fa" }}
                    />
                    <small className="text-muted">UUID leído del dispositivo RFID.</small>
                  </div>

                  {role === "ADMIN" && (
                    <div className="form-group">
                      <label>Cliente</label>
                      <select
                        className="form-control"
                        name="customer"
                        value={newRedeemCode.customer}
                        onChange={this.handleInputChange}
                        required
                      >
                        <option value="">Seleccionar Cliente</option>
                        {customers &&
                          customers
                            .filter((c) => c.Type === "GENERAL" || c.Type === "LICENCIA_BASICA" || c.Type === "LICENCIA_PRO")
                            .sort((a, b) => a.Fullname.localeCompare(b.Fullname))
                            .map((c) => (
                              <option value={c._id} key={c._id}>{c.Fullname}</option>
                            ))}
                      </select>
                    </div>
                  )}

                  <div className="form-group">
                    <label>Válido Desde <span className="text-muted">(opcional)</span></label>
                    <input
                      type="datetime-local"
                      className="form-control"
                      name="valid_from"
                      value={newRedeemCode.valid_from}
                      onChange={this.handleInputChange}
                      min={new Date().toISOString().slice(0, 16)}
                    />
                  </div>
                  <div className="form-group">
                    <label>Válido Hasta <span className="text-muted">(opcional)</span></label>
                    <input
                      type="datetime-local"
                      className="form-control"
                      name="valid_to"
                      value={newRedeemCode.valid_to}
                      onChange={this.handleInputChange}
                      min={newRedeemCode.valid_from || new Date().toISOString().slice(0, 16)}
                    />
                  </div>
                  <small className="text-muted d-block mb-3">
                    <i className="fas fa-info-circle mr-1"></i>
                    Si no se seleccionan fechas, el código no tendrá fecha de caducidad.
                  </small>

                  <div className="form-group">
                    <label>Productos</label>
                    <div className="d-flex mb-2">
                      <select
                        className="form-control mr-2"
                        name="currentProductId"
                        value={this.state.currentProductId}
                        onChange={this.handleProductChange}
                      >
                        <option value="">Seleccionar Producto</option>
                        {LOCKER_TYPES.map((locker) => (
                          <option value={locker.code} key={locker.code}>{locker.name}</option>
                        ))}
                      </select>
                      <input
                        type="number"
                        className="form-control mr-2"
                        name="currentProductQty"
                        value={this.state.currentProductQty}
                        onChange={this.handleProductChange}
                        min="1"
                        max="1"
                        style={{ width: "80px" }}
                      />
                      <button
                        type="button"
                        className="btn btn-vw"
                        onClick={this.addProduct}
                        disabled={newRedeemCode.products.length >= 1 || !this.state.currentProductId}
                      >
                        Añadir
                      </button>
                    </div>
                    {newRedeemCode.products.length >= 1 && (
                      <small className="text-warning">
                        <i className="fas fa-info-circle mr-1"></i>
                        Solo se permite 1 producto por código
                      </small>
                    )}
                    <ul className="list-group">
                      {newRedeemCode.products.map((product, index) => (
                        <li key={index} className="list-group-item">
                          <div className="d-flex justify-content-between align-items-center">
                            <span>{this.getTypeName(product.product_name)} — Cant: {product.product_qty}</span>
                            <button
                              type="button"
                              className="btn btn-sm btn-danger"
                              onClick={() => this.removeProduct(index)}
                            >
                              Eliminar
                            </button>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </form>
              </div>
              <div className="vw-modal__footer">
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={() => this.setState({ showForm: false, pendingUUID: "" })}
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  className="btn bg-vw-dark text-white"
                  onClick={this.handleSubmit}
                  disabled={
                    newRedeemCode.products.length === 0 ||
                    (role === "ADMIN" && !newRedeemCode.customer)
                  }
                >
                  <i className="fas fa-id-badge mr-1"></i>
                  Crear Código de Pulsera
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Table */}
        <div className="redeemcodes-card">
          <div className="card-header-custom">
            <i className="fas fa-list mr-2"></i>
            Lista de Códigos de Pulsera RFID
            <span className="badge badge-secondary ml-2">{filteredCodes.length}</span>
          </div>
          <div className="card-body-custom">
            <div className="table-responsive">
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>UUID</th>
                    <th>Cliente</th>
                    <th>Productos</th>
                    <th>Válido Desde</th>
                    <th>Válido Hasta</th>
                    <th>Estado</th>
                    <th>Creado</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredCodes.length === 0 ? (
                    <tr>
                      <td colSpan={8} className="text-center text-muted py-4">
                        <i className="fas fa-id-badge mr-2"></i>
                        No hay códigos de pulsera RFID registrados.
                      </td>
                    </tr>
                  ) : (
                    filteredCodes.map((rc) => (
                      <tr key={rc._id}>
                        <td style={{ fontFamily: "monospace", fontSize: "12px" }}>{rc.code}</td>
                        <td>{this.getCustomerName(rc.customer)}</td>
                        <td>
                          {rc.products && rc.products.length > 0
                            ? rc.products.map((p) => `${this.getTypeName(p.product_name)} (${p.product_qty})`).join(", ")
                            : "Ninguno"}
                        </td>
                        <td>{rc.valid_from ? new Date(rc.valid_from).toLocaleString() : "—"}</td>
                        <td>{rc.valid_to ? new Date(rc.valid_to).toLocaleString() : "—"}</td>
                        <td>
                          {rc.redeemedAt && rc.redeemedAt.length > 0 ? (
                            <button
                              className="btn btn-sm btn-success text-white"
                              onClick={() => this.showRedeemedModal(rc)}
                            >
                              <i className="fas fa-check-circle mr-1 text-white"></i>
                              Canjeado
                            </button>
                          ) : (
                            <span className="text-danger">
                              <i className="fas fa-times-circle mr-1"></i>
                              No canjeado
                            </span>
                          )}
                        </td>
                        <td>{new Date(rc.createdAt).toLocaleString()}</td>
                        <td>
                          <div style={{ display: "flex", gap: "5px" }}>
                            <button
                              className="btn btn-sm btn-primary"
                              onClick={() => this.openEditModal(rc)}
                              title="Editar"
                            >
                              <i className="fas fa-edit"></i>
                            </button>
                            <button
                              className="btn btn-sm btn-danger"
                              onClick={() => this.handleDeleteRedeemCode(rc._id)}
                              title="Eliminar"
                            >
                              <i className="fas fa-trash"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Redeemed History Modal */}
        {showRedeemedModal && selectedRedeemedCode && (
          <div className="vw-modal">
            <div className="vw-modal__backdrop" onClick={this.closeRedeemedModal} />
            <div className="vw-modal__dialog vw-modal__dialog--redeemed">
              <div className="vw-modal__header">
                <h5 className="m-0">
                  Historial de Canjes — <span style={{ fontFamily: "monospace", fontSize: "13px" }}>{selectedRedeemedCode.code}</span>
                </h5>
                <button type="button" className="close" onClick={this.closeRedeemedModal} aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="vw-modal__body">
                <div className="list-group">
                  {selectedRedeemedCode.redeemedAt.map((redeem, index) => (
                    <div key={index} className="list-group-item">
                      <div className="d-flex flex-wrap justify-content-between align-items-center" style={{ gap: "10px" }}>
                        <div style={{ minWidth: "250px" }}>
                          <strong>Fecha de canje:</strong>{" "}
                          {new Date(redeem.redeem_timestamp).toLocaleString()}
                        </div>
                        <div style={{ minWidth: "150px" }}>
                          <strong>Máquina:</strong> {this.getMachineSerial(redeem.redeem_machine)}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="vw-modal__footer">
                <button type="button" className="btn btn-light" onClick={this.closeRedeemedModal}>
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Edit Modal */}
        {this.state.showEditModal && this.state.editRedeemCode && (
          <div className="vw-modal">
            <div className="vw-modal__backdrop" onClick={this.closeEditModal} />
            <div className="vw-modal__dialog">
              <div className="vw-modal__header">
                <h5 className="m-0">Editar Código de Pulsera RFID</h5>
                <button type="button" className="close" onClick={this.closeEditModal} aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="vw-modal__body">
                <form>
                  <div className="form-group">
                    <label>UUID</label>
                    <input
                      type="text"
                      className="form-control"
                      value={this.state.editRedeemCode.code}
                      readOnly
                      style={{ fontFamily: "monospace", background: "#f8f9fa" }}
                    />
                  </div>
                  {role === "ADMIN" && (
                    <div className="form-group">
                      <label>Cliente</label>
                      <select
                        className="form-control"
                        name="customer"
                        value={this.state.editRedeemCode.customer}
                        onChange={this.handleEditInputChange}
                        required
                      >
                        <option value="">Seleccionar cliente</option>
                        {customers &&
                          customers
                            .filter((c) => c.Type === "GENERAL" || c.Type === "LICENCIA_BASICA" || c.Type === "LICENCIA_PRO")
                            .sort((a, b) => a.Fullname.localeCompare(b.Fullname))
                            .map((c) => (
                              <option key={c._id} value={c._id}>{c.Fullname}</option>
                            ))}
                      </select>
                    </div>
                  )}
                  <div className="form-group">
                    <label>Válido Desde <span className="text-muted">(opcional)</span></label>
                    <input
                      type="datetime-local"
                      className="form-control"
                      name="valid_from"
                      value={this.state.editRedeemCode.valid_from}
                      onChange={this.handleEditInputChange}
                    />
                  </div>
                  <div className="form-group">
                    <label>Válido Hasta <span className="text-muted">(opcional)</span></label>
                    <input
                      type="datetime-local"
                      className="form-control"
                      name="valid_to"
                      value={this.state.editRedeemCode.valid_to}
                      onChange={this.handleEditInputChange}
                    />
                  </div>
                </form>
              </div>
              <div className="vw-modal__footer">
                <button type="button" className="btn btn-light" onClick={this.closeEditModal}>
                  Cancelar
                </button>
                <button
                  type="button"
                  className="btn bg-vw-dark text-white"
                  onClick={this.handleEditSubmit}
                >
                  Actualizar
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  role: state.auth.role,
  type: state.auth.type,
  customerId: state.auth.id,
  customerFullname: state.auth.fullname,
  customer: state.customers.customer,
  wristbandRedeemCodes: state.redeemCodes.wristbandRedeemCodes,
  wristbandRedeemCodesNeedRefresh: state.redeemCodes.wristbandRedeemCodesNeedRefresh,
  wristbandLoading: state.redeemCodes.wristbandLoading,
  wristbandError: state.redeemCodes.wristbandError,
  machines: state.machines.machines,
  customers: state.customers.customers,
});

const mapDispatchToProps = (dispatch) => ({
  fetchWristbandRedeemCodes: bindActionCreators(fetchWristbandRedeemCodes, dispatch),
  addWristbandRedeemCode: bindActionCreators(addWristbandRedeemCode, dispatch),
  updateRedeemCode: bindActionCreators(updateRedeemCode, dispatch),
  deleteRedeemCode: bindActionCreators(deleteRedeemCode, dispatch),
  fetchMachines: bindActionCreators(fetchMachines, dispatch),
  fetchCustomersName: bindActionCreators(fetchCustomersName, dispatch),
  fetchCustomer: bindActionCreators(fetchCustomer, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(WristbandRedeemCodesView);
